export const LONG_DATE_FORMAT = new Intl.DateTimeFormat('en-US', {
  dateStyle: 'long',
});
